// extracted by mini-css-extract-plugin
export default {"grid":"Heading_grid__X3Wxb","container":"Heading_container__B1lx6"};